<template>
  <q-dialog v-if="formProperty && formProperty.ocrType" v-model="visibleDlg" class="ocrDlg">
    <q-card>
      <q-card-section class="q-pb-none">
        <div class="row items-center">
          <div class="text-h6">{{ formProperty.ocrType === 1 ? "Strichcode Scan" : formProperty.ocrType === 2 ? "QR-Code Scan" : "Schrifterkennung" }}</div>
          <q-space/>
          <q-btn icon="close" flat round dense v-close-popup/>
          <div class="text-subtitle2" v-if="formProperty.ocrType === 3">Bitte den Text genau zentrieren, auf gleichmäßige Ausleuchtung achten und das Bild gerade fotografieren.</div>
        </div>
      </q-card-section>

      <q-card-section>
        <qrcode-stream height="40px" @decode="onQRDone" @init="onInit" v-if="formProperty.ocrType===2"/>
        <ocr-comp @OCRDone="onOCRDone" @OCRError="onOCRError" v-if="formProperty.ocrType===3"/>
        <StreamBarcodeReader @loaded="" @result="onOCRDone" v-if="formProperty.ocrType===1"></StreamBarcodeReader>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn color="primary" flat label="OCR Scan" v-if="formProperty.ocrType===3" @click="clickOCR"/>
        <q-btn label="Abbrechen" color="grey" flat @click="visibleDlg=false"/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>

import {StreamBarcodeReader} from "vue-barcode-reader";
import OcrComp from "components/tech/ocr-comp.vue";
import {QrcodeCapture, QrcodeDropZone, QrcodeStream} from 'vue3-qrcode-reader'

export default {
  props: [
    'formProperty',
    'showDlg'
  ],
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
    OcrComp,
    StreamBarcodeReader
  },
  computed: {
    visibleDlg: {
      get() {
        return this.showDlg;
      },
      set(value) {
        this.$emit('dlgClose');
      }
    }
  },
  data() {
    return {}
  },

  methods: {
    // -----------------------------------------------------------
    // ---------------------- OCR Scan -----------------------
    // -----------------------------------------------------------
    clickOCR() {
      this.eventBus.doOCR()
    },

    onOCRDone(result) {
      //logger.info("onOCRDone: " + result.text)
      this.visibleDlg = false
      this.$emit('ocrDone', result.text);
    },

    onQRDone(result) {
      // logger.info("onQRDone: " + result)
      this.visibleDlg = false
      this.$emit('ocrDone', result);
    },

    onOCRError(error) {
      this.visibleDlg = false
      this.formProperty.errorMsg = this.getCameraInitErrorMsg(error)
      this.formProperty.invalid = true
    },

    // -----------------------------------------------------------
    // ---------------------- QR Code Scan -----------------------
    // -----------------------------------------------------------
    async onInit(promise) {
      this.ocrInitLoading = true
      try {
        await promise
      } catch (error) {
        this.visibleDlg = false
        this.formProperty.errorMsg = this.getCameraInitErrorMsg(error)
        this.formProperty.invalid = true
      } finally {
        this.ocrInitLoading = false
      }
    },

    getCameraInitErrorMsg(error) {
      let result = ""
      if (error.name === 'NotAllowedError') {
        result = "Fehler: Kamerazugriff wurde nicht erlaubt"
      } else if (error.name === 'NotFoundError') {
        result = "Fehler: keine Kamera verfügbar"
      } else if (error.name === 'NotSupportedError') {
        result = "Fehler: HTTPS benötigt"
      } else if (error.name === 'NotReadableError') {
        result = "Fehler: wird die Kamera bereits verwendet?"
      } else if (error.name === 'OverconstrainedError') {
        result = "Fehler: Kamera kann nicht benutzt werden"
      } else if (error.name === 'StreamApiNotSupportedError') {
        result = "Fehler: Stream API wird von diesem Bowser nicht unterstützt"
      }
      return result
    },

    mounted: function () {
    }
  }
}
</script>

<style lang="sass">
.ocrDlg
  height: 50%

  .q-field--dense
    font-size: 13px

  .q-field--dense .q-field__bottom
    padding-top: 2px
</style>
